module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("How to become a Resident DJ?")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("For music producers and YouTube promoters only.")]), _vm._v(" "), _c('li', [_vm._v("You must have music samples on SoundCloud, YouTube, BandCamp, or a personal website.")]), _vm._v(" "), _c('li', [_vm._v("You must be able to demonstrate you play more than just your own music.")]), _vm._v(" "), _c('li', [_vm._v("DJs and Producers: a minimum of 5 tracks/mixes of reasonable quality written within our room's genre requirements.")]), _vm._v(" "), _c('li', [_vm._v("Promoters: 1,000+ followers/subscribers via any medium OR a promising channel with professional graphics, good artist outreach, etc.")])])])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showType),
      expression: "showType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Show All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "producer"
    }
  }, [_vm._v("Show Producers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "promoter"
    }
  }, [_vm._v("Show Promoters")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.rdjs), function(rdj) {
    return (_vm.showType === 'all' ? rdj.type === 'promoter' || rdj.type === 'producer' : rdj.type === _vm.showType) ? _c('div', {
      staticClass: "column is-2"
    }, [_c('a', {
      attrs: {
        "href": rdj.youtube || rdj.soundcloud,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": rdj.imageUrl,
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title name"
    }, [_vm._v(_vm._s(rdj.name))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle location"
    }, [_vm._v(_vm._s(rdj.location))])])])])])])]) : _vm._e()
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-rdj"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  })]), _vm._v("Resident DJs")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Meet the artists.\n            ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f06b72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Rdj.vue
// module id = 169
// module chunks = 1